import React from "react";
import "./style.scss";
// import Toys from "../../../../assets/images/rocking-horse.svg";
import { useGetAboutBannerQuery } from "../../../../services/AboutAPI";
import { useGetAllCategoriesQuery } from "../../../../services/productsAPI";
import Loader from "../../fullPageLoader"

function Index() {

  const { data, error, isLoading } = useGetAboutBannerQuery();

  const {
    error: categoryError,
    isLoading: categoryIsLoading,
  } = useGetAllCategoriesQuery();

  if (isLoading || categoryIsLoading) return <Loader />;
  if (error || categoryError) return <p>Failed to load Data.</p>;

  // Assuming 'data' contains the banners for different pages
  const shopBanner = data?.data?.find((item) => item.page_name === "Shop");

  return (
    <div>
      <section
        className="shop-banner"
        style={{
          backgroundImage: `url(${shopBanner?.banner_image})`, // Set dynamic background image
          backgroundSize: "cover", // Make sure the background image covers the section
     
        }}
      >
        <div className="banner-overlay"></div>
        <div className="banner-heading">
          <h1>Shop</h1>
        </div>
        {/* <div className="available-products">
          <div className="product-items d-flex">
            {categoryData?.data?.map((category) => (
              <p key={category.id}>
                <img
                  src={category.category_icon_image_url}
                  alt={category.category_name}
                  width={20}
                />
                {category.category_name}
              </p>
            ))}
          </div>
        </div> */}
      </section>
    </div>
  );
}

export default Index;
